import { HasClassName } from 'models/HasClassName'
import { FunctionComponent } from 'react'

interface Props extends HasClassName {
  onClick?: () => void
}

export const SpaceshipIcon: FunctionComponent<Props> = ({ className, onClick }) => {
  return (
    <svg
      className={className}
      onClick={onClick}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
    <path
      d="M13.1301 22.19L11.5001 18.36C13.0701 17.78 14.5401 17 15.9001 16.09L13.1301 22.19ZM5.64006 12.5L1.81006 10.87L7.91006 8.10003C7.00006 9.46003 6.22006 10.93 5.64006 12.5ZM21.6101 2.39003C21.6101 2.39003 16.6601 0.269033 11.0001 5.93003C8.81006 8.12003 7.50006 10.53 6.65006 12.64C6.37006 13.39 6.56006 14.21 7.11006 14.77L9.24006 16.89C9.79006 17.45 10.6101 17.63 11.3601 17.35C13.5001 16.53 15.8801 15.19 18.0701 13C23.7301 7.34003 21.6101 2.39003 21.6101 2.39003ZM14.5401 9.46003C13.7601 8.68003 13.7601 7.41003 14.5401 6.63003C15.3201 5.85003 16.5901 5.85003 17.3701 6.63003C18.1401 7.41003 18.1501 8.68003 17.3701 9.46003C16.5901 10.24 15.3201 10.24 14.5401 9.46003ZM8.88006 16.53L7.47006 15.12L8.88006 16.53ZM6.24006 22L9.88006 18.36C9.54006 18.27 9.21006 18.12 8.91006 17.91L4.83006 22H6.24006ZM2.00006 22H3.41006L8.18006 17.24L6.76006 15.83L2.00006 20.59V22ZM2.00006 19.17L6.09006 15.09C5.88006 14.79 5.73006 14.47 5.64006 14.12L2.00006 17.76V19.17Z"
      fill="currentColor"
    />
    </svg>
  )
}
